export const GET_METABASE_DASHBOARD = "GET_METABASE_DASHBOARD";
export const GET_METABASE_DASHBOARD_COMPLETED = "GET_METABASE_DASHBOARD_COMPLETED";
export const GET_METABASE_DASHBOARD_FAILED = "GET_METABASE_DASHBOARD_FAILED";

// Récupère l'URL d'iframe d'embed Metabase (token signé côté serveur, TTL court).
// Le token n'est jamais codé en dur dans le front : il est fabriqué par l'API.
export const getMetabaseDashboard = () => ({
  type: GET_METABASE_DASHBOARD,
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/metabase/dashboard.json`,
    method: "GET",
  },
});
